// extracted by mini-css-extract-plugin
export default {"auth_form_container":"AuthorizationForm_auth_form_container__TzPEP","auth_card":"AuthorizationForm_auth_card__p8MW0","auth_header":"AuthorizationForm_auth_header__Oa59h"};